<template>
  <div
    :class="[$style.base, { [$style.smallScreen]: $screen === 's', [$style.mediumScreen]: $screen === 'm' }]"
  >
    <Flex direction="column">
      <Flex wrap>
        <BaseDropdown
          v-model="selectedWeek"
          :options="[{ label: $t('insights.week_selection.current'), value: 'current' }, { label: $t('insights.week_selection.next'), value: 'next' }, { label: $t('insights.week_selection.custom'), value: 'custom' }]"
          v-test="'insights-week'"
        />
        <BaseDatePicker
          v-if="selectedWeek === 'custom'"
          v-model="selectedCustomDate"
          range="week"
          v-test="'insights-week-custom'"
        />
        <BaseHeading>
          {{ filters.date(date, { format: 'long' }) }}-
          {{ filters.date(endAt, { format: 'long' }) }}
        </BaseHeading>
      </Flex>
      <Header
        v-bind="{ totalAppointments, totalScheduledHours, totalAvailableHours }"
      />
      <div :class="$style.row">
        <Services />
        <Availability @loaded="onAvailabilityLoaded" />
      </div>
      <Appointments @loaded="onAppointmentsLoaded" />
      <Banner />
    </Flex>
  </div>
</template>

<script
  setup
  lang="ts"
>
import { useStorage } from '@vueuse/core';
import dayjs from '@/dayjs';
import filters from '@/filters';
import Appointments from './appointments/index.vue';
import Availability from './availability/index.vue';
import Banner from './Banner.vue';
import Header from './header/index.vue';
import Services from './services/index.vue';

const selectedWeek = useStorage<'current' | 'next' | 'custom'>(
  'insightsSelectedWeek',
  'current',
);
const selectedCustomDate = useStorage(
  'insightsSelectedDate',
  dayjs().format('YYYY-MM-DD'),
);
const date = computed(() => {
  if (selectedWeek.value === 'current') {
    return dayjs().format('YYYY-MM-DD');
  } else if (selectedWeek.value === 'next') {
    return dayjs().add(1, 'week').format('YYYY-MM-DD');
  } else {
    return selectedCustomDate.value;
  }
});
const startAt = computed(() =>
  dayjs(date.value).startOf('isoWeek').format('YYYY-MM-DD'),
);
const endAt = computed(() =>
  dayjs(date.value).endOf('isoWeek').format('YYYY-MM-DD'),
);

provide('startAt', startAt);
provide('endAt', endAt);

const totalAppointments = ref(0);
const onAppointmentsLoaded = (total: number) => {
  totalAppointments.value = total;
};

const totalScheduledHours = ref(0);
const totalAvailableHours = ref(0);
const onAvailabilityLoaded = (availability: {
  scheduledHours: number;
  availableHours: number;
}) => {
  totalScheduledHours.value = availability.scheduledHours;
  totalAvailableHours.value = availability.availableHours;
};
</script>

<style
  lang="scss"
  module
>
.base {
  max-width: 1100px;
  margin: 0 auto;
}

.row {
  display: flex;
  gap: $spacing;

  .base.smallScreen &, .base.mediumScreen & {
    flex-direction: column;
  }

  .base:not(.smallScreen):not(.mediumScreen) & {
    & > * {
      width: 50%;
    }
  }
}
</style>
